import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function UrgencyBar() {
  const {
    minutes,
    seconds
  } = useCountdown(30);
  return <div className="fixed top-0 left-0 right-0 z-50 bg-brand-black border-b border-brand-gold py-2 px-4 shadow-lg" data-id="element-237">
      <div className="max-w-7xl mx-auto flex items-center justify-between text-xs sm:text-sm font-medium" data-id="element-238">
        <div className="flex items-center space-x-2 truncate pr-4" data-id="element-239">
          <div className="w-2 h-2 rounded-full bg-brand-red animate-pulse-red flex-shrink-0" data-id="element-240" />
          <span className="text-brand-text truncate" data-id="element-241">
            <span className="hidden sm:inline" data-id="element-242">
              ⚡ OFERTA DE LANZAMIENTO —{' '}
            </span>
            Solo quedan 17 accesos al precio especial
          </span>
        </div>
        <div className="flex items-center space-x-1 text-brand-gold font-bold flex-shrink-0" data-id="element-243">
          <span data-id="element-244">{minutes}</span>
          <span data-id="element-245">:</span>
          <span data-id="element-246">{seconds}</span>
        </div>
      </div>
    </div>;
}